<template>

  <!-- Modal -->
  <div class="modal fade" id="emargement_modal" tabindex="-1" aria-labelledby="emargement_modal_label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="emargement_modal_label">Emargement</h5>
        </div>
        <div class="modal-body">
          En cliquant sur "Valider", je confirme ma présence en cours ce jours ({{date_jour}}).
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="set_presence">Valider</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: {},

  data: function () {
    return {
      date_jour: "",
    }
  },

  mounted() {
    this.init()
  },

  methods: {

    init: function() {
      const _this = this

      get_token_2().then(function (response) {

        let [secure_key, customer_id, api_url, customer] = response
        api_url += 'emargement_presences/need_presence.json'
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios({
          method: 'get',
          url: api_url
        })
            .then(function (response) {

              if (response.data.need_presence) {
                const today = new Date()
                _this.date_jour = today.toLocaleDateString("fr")
                $('#emargement_modal').modal('show');
              } else {
              }
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
            });
      })
    },

    set_presence: function () {
      const _this = this

      get_token_2().then(function (response) {

        let [secure_key, customer_id, api_url, customer] = response
        api_url += "emargement_presences.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios({
          method: 'post',
          url: api_url
        })
            .then(function (response) {
              _this.message = "Dossier mis à jour"
              _this.message_type = "alert-success"
              $('#emargement_modal').modal('hide');
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
            });
      })
    },
  }
}
</script>

<style scoped>

</style>